import { useCallback } from 'react';
import { isEmpty, map, pick } from 'ramda';
import { hasDaysDiffStrict } from 'js/utils/date.util';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { MAX_PERIOD_DAYS } from '../constants';
import { intoDate, startOfDay } from '../helpers';

export const useValidate = () => {
    const translate = useComponentTranslations();

    return useCallback((values) => {
        const dates = pick(['from', 'until'], values);

        if (isEmpty(dates)) {
            return;
        }

        const { from, until } = map(intoDate, dates);

        if (from > until) {
            return map(() => translate('filter.error.timePeriod'), dates);
        }

        if (hasDaysDiffStrict(from, startOfDay(until), MAX_PERIOD_DAYS)) {
            return map(() => translate('filter.error.range', [MAX_PERIOD_DAYS]), dates);
        }
    }, [translate]);
};
